import { Check, ChevronRight, CircleAlert, PackageCheck, TrendingUp } from "lucide-react";

const iconByType = {
  Opportunity: TrendingUp,
  Operations: PackageCheck,
  Risk: CircleAlert,
};

export default function ActionQueue({ actions, filter, onFilter, onComplete }) {
  const filters = ["All", "Opportunity", "Risk", "Operations"];
  const visibleActions = actions.filter((action) => filter === "All" || action.type === filter);

  return (
    <section className="queue-section" id="priority-queue" data-testid="priority-action-queue">
      <div className="section-heading">
        <div>
          <p className="eyebrow">Your work, ordered</p>
          <h2>Today’s priorities</h2>
        </div>
        <div className="filter-tabs" data-testid="action-filter-tabs">
          {filters.map((item) => (
            <button
              className={`filter-tab ${filter === item ? "is-selected" : ""}`}
              data-testid={`action-filter-${item.toLowerCase()}-button`}
              key={item}
              type="button"
              onClick={() => onFilter(item)}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
      <div className="action-list" data-testid="action-list">
        {visibleActions.map((action, index) => {
          const Icon = iconByType[action.type];
          return (
            <article
              className={`action-row ${action.is_complete ? "is-complete" : ""}`}
              data-testid={`action-row-${action.id}`}
              key={action.id}
              style={{ animationDelay: `${index * 70}ms` }}
            >
              <button
                className="complete-button"
                type="button"
                aria-label={`Mark ${action.title} ${action.is_complete ? "incomplete" : "complete"}`}
                onClick={() => onComplete(action)}
                data-testid={`complete-action-${action.id}-button`}
              >
                {action.is_complete && <Check size={14} strokeWidth={2.6} />}
              </button>
              <div className={`action-icon ${action.type.toLowerCase()}`}>
                <Icon size={19} strokeWidth={1.8} />
              </div>
              <div className="action-content">
                <div className="action-title-line">
                  <span className={`type-chip ${action.type.toLowerCase()}`}>{action.type}</span>
                  <span className="action-due" data-testid={`action-due-${action.id}`}>{action.due}</span>
                </div>
                <h3 data-testid={`action-title-${action.id}`}>{action.title}</h3>
                <p>{action.detail}</p>
              </div>
              <div className="action-impact">
                <strong data-testid={`action-impact-${action.id}`}>{action.impact}</strong>
                <button
                  className="open-action-button"
                  type="button"
                  aria-label={`Open ${action.title}`}
                  data-testid={`open-action-${action.id}-button`}
                >
                  <ChevronRight size={19} strokeWidth={1.8} />
                </button>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}